/**
 * Configuration for jobs in this app.
 */
const jobiqoJobsConfig = require('./../src/jobiqo/config/jobs');
const mergeDeepRight = require('ramda/src/mergeDeepRight');
const { locationFixtures } = require('./fixtures');

module.exports = mergeDeepRight(jobiqoJobsConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    SHOW_PUBLISHED_DATE: false,
    GEO_INFO: {
      radius: {
        defaultValue: 50,
      },
      fixtures: locationFixtures,
    },
    FACETS: {
      yearsOfExperience: null,
    },
  },
});
